import React, { useContext, useState, useEffect, useRef } from "react";
import { GlobalContext } from "./App";
import TranslateText from "./translateText";

const sampleMessages = {
  customer_001: [
    {
      messageId: "msg_1",
      msgAuthor: "customer",
      content: "Hola, necesito ayuda con mi pedido.",
      translatedText: "Hello, I need help with my order.",
      sourceLanguage: "es",
      timestamp: Date.now() - 100000,
    },
    {
      messageId: "msg_2",
      msgAuthor: "agent",
      content: "Sure! Can you share your order number?",
      translatedText: "Claro, ¿puede compartir su número de pedido?",
      sourceLanguage: "en",
      timestamp: Date.now() - 80000,
    },
    {
      messageId: "msg_3",
      msgAuthor: "customer",
      content: "Sí, es ORD-45892.",
      translatedText: "Yes, it is ORD-45892.",
      sourceLanguage: "es",
      timestamp: Date.now() - 60000,
    },
    {
      messageId: "msg_4",
      msgAuthor: "agent",
      content: "Thank you. Let me check the status for you.",
      translatedText: "Gracias. Déjeme verificar el estado para usted.",
      sourceLanguage: "en",
      timestamp: Date.now() - 40000,
    },
  ],

  customer_002: [
    {
      messageId: "msg_5",
      msgAuthor: "customer",
      content: "Bonjour, mon paiement a échoué.",
      translatedText: "Hello, my payment failed.",
      sourceLanguage: "fr",
      timestamp: Date.now() - 120000,
    },
    {
      messageId: "msg_6",
      msgAuthor: "agent",
      content: "Please try again using another card.",
      translatedText: "Veuillez réessayer avec une autre carte.",
      sourceLanguage: "en",
      timestamp: Date.now() - 90000,
    },
  ],
};


function Chatroom({ session }) {
  const {
    currentContactId,
    messages,
    setMessages,
    agentLanguage,
    languages,
    translateProviders,
    setAgentLanguage,
  } = useContext(GlobalContext);
  const [menuOption, setMenuOption] = useState('chat')
  const [translateProvider, setTranslateProvider] = useState(null)
  const [newMessage, setNewMessage] = useState("");
  const messagesEndRef = useRef(null);

  const currentMessages = messages[currentContactId] || [];
  // const currentMessages = sampleMessages.customer_001;

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  //   useEffect(() => {
  //     if (currentContactId) {
  //       const savedMessages = localStorage.getItem(
  //         `chatMessages-${currentContactId}`
  //       );
  //       if (savedMessages) {
  //         const parsedMessages = JSON.parse(savedMessages);
  //         // Only update if we don't already have messages for this contact
  //         if (!messages[currentContactId]) {
  //           setMessages((prev) => ({
  //             ...prev,
  //             [currentContactId]: parsedMessages,
  //           }));
  //         }
  //       }
  //     }
  //   }, [currentContactId]);

  useEffect(() => {
    scrollToBottom();
  }, [currentMessages]);

  //   useEffect(() => {
  //     if (currentContactId && messages[currentContactId]) {
  //       localStorage.setItem(
  //         `chatMessages-${currentContactId}`,
  //         JSON.stringify(messages[currentContactId])
  //       );
  //     }
  //   }, [messages, currentContactId]);

  const handleSendMessage = async (e) => {
    e.preventDefault();
    if (!newMessage.trim() || !currentContactId || !session) return;

    const currentSession = session.find(
      (s) => Object.keys(s)[0] === currentContactId
    );
    if (!currentSession) return;

    try {
      const lastCustomerMessage = currentMessages
        .filter((msg) => msg.msgAuthor === "customer")
        .slice(-1)[0];

      const msgContent = await new TranslateText(
        newMessage.trim(),
        "auto",
        lastCustomerMessage?.sourceLanguage || "en"
      ).getTranslatedText();
      console.log(msgContent);
      await currentSession[currentContactId].sendMessage({
        message: msgContent.TranslatedText,
        contentType: "text/plain",
      });
      setNewMessage("");
    } catch (error) {
      console.error("Error sending message:", error);
    }
  };

  const formatTimestamp = (timestamp) => {
    return new Date(timestamp).toLocaleTimeString();
  };

  function handleOpenSettings() {
    setMenuOption((prev) => prev === 'chat' ? 'setting' : 'chat')
  }

  return (
    <>
      <div className="chat-container bg-light border rounded-3 d-flex flex-column h-100">

        <div style={{
          backgroundColor: 'var(--grey-color-3)'
        }} className="px-3 chat-header text-white p-2 rounded-top d-flex justify-content-between align-items-center mb-2">
          <h6 style={{ fontSize: 18 }} className="m-0">
            Live Translation Chat
            {/* {currentContactId ? `#${currentContactId}` : ""} */}
          </h6>
          <div className="preference-setting" role="button" onClick={handleOpenSettings} style={{
            fontSize: 18
          }}>
            {menuOption === 'chat' ?
              <i class="bi bi-gear-wide-connected"></i>
              : <i class="bi bi-chat-right-text"></i>
            }
          </div>

          {/* <div className="language-badge px-2 py-1 bg-white text-primary rounded-pill small">
          {languages[agentLanguage]}
        </div> */}
        </div>
        {menuOption === 'chat' ?
          <>

            <div className="chat-messages flex-grow-1 p-3 overflow-auto">
              {currentMessages.map((msg, index) => (
                <div
                  key={msg.messageId}
                  className={`message mb-3 ${msg.msgAuthor === "agent" ? "text-end" : ""
                    }`}
                >
                  <div
                    className={`d-inline-block p-3 rounded-3 ${''
                      // msg.msgAuthor === "agent"
                      // ? "bg-primary text-white"
                      // : "bg-secondary bg-opacity-10"
                      }`}
                    style={{
                      maxWidth: "75%",
                      ...(msg.msgAuthor === 'agent' ?
                        {
                          backgroundColor: 'var(--secondary-color-2)',
                          color: 'var(--grey-color-10)'
                        } : {
                          backgroundColor: 'var(--grey-color-10)',
                          color: 'var(--grey-color-1)'
                        })

                    }
                    }
                  >
                    <div className="message-content mb-1 fw-bold">
                      {msg.translatedText}
                    </div>
                    <div className="translated-message font-italic small">
                      {msg.content}
                    </div>
                    <div className="message-meta d-flex justify-content-between align-items-center small text-opacity-75 mt-2">
                      {/* <span className="message-language">
                  {msg.content}
                </span> */}
                      <span className="message-time">
                        {formatTimestamp(msg.timestamp)}
                      </span>
                    </div>
                  </div>
                </div>
              ))}
              <div ref={messagesEndRef} />
            </div>

            <form
              onSubmit={handleSendMessage}
              className="chat-input p-3 bg-white border-top"
            >
              <div className="input-group">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Type your message..."
                  value={newMessage}
                  onChange={(e) => setNewMessage(e.target.value)}
                  disabled={!currentContactId}
                />
                <button
                  type="submit"
                  className="btn btn-primary"
                  style={{
                    backgroundColor: 'var(--secondary-color-5)'
                  }}
                  disabled={!currentContactId || !newMessage.trim()}
                >
                  Send
                </button>
              </div>
            </form>
          </>

          : <div className="m-3">
            <div className="mb-3 language-selector">
              <label for="languageSelect" class="form-label">Language Select</label>
              <select
                value={agentLanguage}
                onChange={(e) => setAgentLanguage(e.target.value)}
                className="select-language form-select form-control"
                id="languageSelect"
              >
                {Object.entries(languages).map(([code, name]) => (
                  <option key={code} value={code}>
                    {name}
                  </option>
                ))}
              </select>
            </div>
            <div className="mb-3 translate-api">
              <label for="translateApiSelect" class="form-label">Translation Provider</label>
              <select
                value={translateProvider}
                onChange={(e) => setTranslateProvider(e.target.value)}
                className="select-language form-select form-control"
                id="translateApiSelect"
              >
                {Object.entries(translateProviders).map(([code, name]) => (
                  <option key={code} value={code}>
                    {name}
                  </option>
                ))}
              </select>
            </div>
          </div>}

      </div >
    </>
  );
}

const Message = ({ chat, user }) => {
  // const timestampObj = new Date(chat.timestamp);
  // const timestamp = `${timestampObj.getHours()% 12 || 12}:${timestampObj.getMinutes()}`;
  const timestamp = new Date(chat.timestamp).toLocaleTimeString("en-US", {
    // en-US can be set to 'default' to use user's browser settings
    hour: "2-digit",
    minute: "2-digit",
  });
  const translatedText =
    chat.msgAuthor === "agent"
      ? chat.content
      : chat.translatedMessageData.TranslatedText;
  const msgId = chat.messageId;
  const sourceText = chat.content;
  const msgAuthor = chat.msgAuthor;
  return (
    <li
      className="Message"
      style={{
        display: "flex",
        justifyContent: "space-between",
        flexDirection: msgAuthor === "agent" ? "row-reverse" : "unset",
      }}
    >
      <div
        className="border rounded px-3 py-2 w-75"
        style={{
          backgroundColor: msgAuthor === "agent" ? "#e8f6f8" : "#ededed",
        }}
      >
        <p className="fw-semibold">{sourceText}</p>
        <p className="text-danger">{translatedText}</p>
      </div>
      <p className="m-auto text-muted">{timestamp}</p>
    </li>
  );
};

export default Chatroom;
